export const stringifyUnexpectedError = error =>
  (error instanceof Error ? error : JSON.stringify(error));
